import { ParamMap, Params } from '@angular/router';

/** Список аппаратов. */
export const DEVICES_LIST_URL = '/devices';

/** Query-параметры ссылки на список аппаратов с фильтром: с карточек площадок и контейнеров. */
export enum DevicesLinkQueryParam {
  FacilityIds = 'facilityIds',
  ContainerIds = 'containerIds',
}

export interface IDevicesLinkFilter {
  facilityIds: string[];
  containerIds: string[];
}

const GUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const getDevicesLinkQueryParams = (filter: Partial<IDevicesLinkFilter>): Params => ({
  [DevicesLinkQueryParam.FacilityIds]: filter.facilityIds,
  [DevicesLinkQueryParam.ContainerIds]: filter.containerIds,
});

/** Параметры, которыми ссылка передаёт фильтр: `null` удаляет их из адреса. */
export const DEVICES_LINK_CLEARED_QUERY_PARAMS: Params = {
  [DevicesLinkQueryParam.FacilityIds]: null,
  [DevicesLinkQueryParam.ContainerIds]: null,
};

export const hasDevicesLinkQueryParams = (params: ParamMap): boolean =>
  Object.values(DevicesLinkQueryParam).some((name: DevicesLinkQueryParam): boolean =>
    params.has(name),
  );

/**
 * Фильтр из адреса. Адрес можно поправить руками, поэтому берём только id вида GUID:
 * иначе API ответит 400 на весь список. `null` — ссылка без фильтра.
 */
export const readDevicesLinkFilter = (params: ParamMap): IDevicesLinkFilter | null => {
  const readIds = (name: DevicesLinkQueryParam): string[] =>
    params.getAll(name).filter((id: string): boolean => GUID_PATTERN.test(id));

  const filter: IDevicesLinkFilter = {
    facilityIds: readIds(DevicesLinkQueryParam.FacilityIds),
    containerIds: readIds(DevicesLinkQueryParam.ContainerIds),
  };

  return filter.facilityIds.length > 0 || filter.containerIds.length > 0 ? filter : null;
};
